import { AuthAPI, AuthState } from '@/types/auth'
import { PermissionModal } from '../utils'

export default function convertAuthUser(apiResponse: AuthAPI): AuthState {
  const { user, access_token } = apiResponse

  const initialState: AuthState = {
    user: user,
    token: access_token,
    client: null,
    permissions: user?.permissions || PermissionModal,
    isLoading: false
  }

  return initialState
}
